import type { WindowDescriptor } from '@krp/client-runtime'

import type { ScheduleUiState } from '../reducer'

/** Окна пакета: адрес, подпись, место в меню — один раз (R11). Содержимое окна — binding приложения. */
export const SCHEDULE_WINDOWS = {
  home: 'schedule.home',
  place: 'schedule.place',
  cashiers: 'schedule.cashiers',
  newPlace: 'schedule.new-place',
  editPlace: 'schedule.edit-place',
} as const

/** Права Platform (матрица Kalmykov Access): смотреть график и править его. Это только отражение сервера — службы проверяют их сами. */
export const SCHEDULE_VIEW = 'platform:schedule:view'
export const SCHEDULE_MANAGE = 'platform:schedule:manage'

export const scheduleWindows: readonly WindowDescriptor<ScheduleUiState>[] = [
  {
    // Вход раздела: плитки объектов. Без права `view` пункта в меню нет; по прямому адресу окно покажет отказ службы дословно.
    kind: SCHEDULE_WINDOWS.home,
    scope: 'global',
    paths: ['/schedule'],
    label: 'График выхода',
    menu: { group: 'work', order: 50, icon: 'schedule', requires: SCHEDULE_VIEW },
  },
  {
    // График одного объекта: адрес несёт объект и месяц — страница открывается ссылкой, переживает обновление и «назад» ведёт к плиткам.
    // Адрес без месяца открывает текущий.
    kind: SCHEDULE_WINDOWS.place,
    scope: 'global',
    paths: ['/schedule/places/:placeId/:month', '/schedule/places/:placeId'],
    label: 'График объекта',
    presentation: 'page',
  },
  {
    // Месяц по кассирам: выбран один кассир, строки — объекты, столбцы — дни. Месяц в адресе, как и в календаре объекта; без месяца — текущий.
    kind: SCHEDULE_WINDOWS.cashiers,
    scope: 'global',
    paths: ['/schedule/cashiers/:month', '/schedule/cashiers'],
    label: 'График по кассирам',
    presentation: 'page',
  },
  {
    kind: SCHEDULE_WINDOWS.newPlace,
    scope: 'global',
    paths: ['/schedule/new-place'],
    label: 'Новый объект',
    size: 'sm',
  },
  {
    kind: SCHEDULE_WINDOWS.editPlace,
    scope: 'global',
    paths: ['/schedule/edit-place/:placeId'],
    label: 'Изменить объект',
    size: 'sm',
  },
]
